<template>
    <main id="home-wrapper">
        <div>
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    {
                        title: 'Payment Gateway',
                        url: app_url + '/event',
                        status: true
                    }
                ]"
            ></breadcrumb>
            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <div class="wrapper-popup">
                        <div class="card-popup">
                            <div v-if="timeRemaining > 0" class="wrapper-va">
                                <div
                                    v-if="isPaymentSuccess"
                                    class="inner-va-information"
                                >
                                    <h5>
                                        <i class="fa fa-clock-o"></i> Payment
                                        Success
                                    </h5>
                                    <p>
                                        Total:
                                        <span class="va-total"
                                            >Rp 20.000.00</span
                                        >
                                    </p>
                                    <p>
                                        Pembayaran berhasil
                                    </p>
                                </div>
                                <div v-else class="inner-va-information">
                                    <h5>
                                        <i class="fa fa-clock-o"></i> Waiting
                                        for payment
                                    </h5>
                                    <p>
                                        Total:
                                        <span class="va-total"
                                            >Rp 20.000.00</span
                                        >
                                    </p>
                                    <p>
                                        Bayar dalam waktu
                                        <span class="va-timeout countdownTime">
                                            {{ minutes }} menit
                                            {{ seconds }} detik
                                        </span>
                                        sebelum masa berlaku QRIS habis, dan
                                        akan otomatis pembayaran di alihkan
                                        menjadi COD.
                                    </p>
                                </div>
                                <div
                                    v-if="isPaymentSuccess === false"
                                    class="inner-va-number"
                                >
                                    <div
                                        v-if="loader"
                                        class="loading loading-double"
                                    ></div>
                                    <div v-else class="va-number">
                                        <!-- <img :src="`https://quickchart.io/qr?margin=1&size=300x300&text=${payment_detail.qr_string}`" alt="qr-code"> -->
                                        <qrcode-vue
                                            :value="payment_detail.qr_string"
                                            :size="300"
                                            level="M"
                                        ></qrcode-vue>
                                    </div>
                                    <div
                                        v-if="loaderCheck"
                                        class="loading loading-double"
                                    ></div>
                                    <div v-else class="va-check">
                                        <!-- <a
                                            @click="simulate()"
                                            class="btn btn-red"
                                            >Simulate</a
                                        >
                                        <a
                                            @click="checkPaymentStatus()"
                                            class="btn btn-red"
                                            >Cek Pembayaran</a
                                        > -->
                                        <a
                                            @click="downloadQrCode"
                                            class="btn btn-red"
                                            >Download QR</a
                                        >
                                    </div>
                                </div>
                            </div>
                            <div v-else class="wrapper-va">
                                <div class="inner-va-information">
                                    <h5>
                                        <i class="fa fa-clock-o"></i> Payment
                                        expired
                                    </h5>
                                    <p>
                                        Total:
                                        <span class="va-total"
                                            >Rp 20.000.00</span
                                        >
                                    </p>
                                    <p class="text-expired-payment">
                                        Masa berlaku pembayaran telah habis dan
                                        otomatis di alihkan menjadi COD.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>
<script>
import BreadCrumb from "../../widget/BreadCrumb";
import { encrypt, decrypt } from "../../../lib/crypto";
import QrcodeVue from "qrcode.vue";
import axios from "axios";
export default {
    components: {
        breadcrumb: BreadCrumb,
        QrcodeVue
    },
    data() {
        return {
            loader: false,
            loaderCheck: false,
            cdn_url: cdn_url,
            base_url: "",
            app_url: "",
            api_url: "",
            event: {},
            event_attend: {},
            user: {},
            account_number: "",
            copy_text: "Copy code",
            transaction: {},
            payment_detail: {},
            message: "",
            timeRemaining: 0, // Waktu tersisa dalam detik
            timer: null,
            formSimulate: new Form({
                _token: token,
                id: ""
            }),
            formUpdate: new Form({
                _token: token,
                external_id: ""
            }),
            isPaymentSuccess: false,
            isCheckingPayment: false
        };
    },
    created() {
        const updatePoliceNumber = localStorage.getItem("update-police-number");
        const event = localStorage.getItem("event-hbd");
        if (!event) {
            window.location.href = `${this.event.detail_url_web}`;
        } else {
            this.event = JSON.parse(event);
            this.handleGetDataTransactionLocalStorage();
            this.handleGetDataEventAttendLocalStorage();
        }
        if (!updatePoliceNumber) {
            window.location.href = `${this.event.detail_url_web}/verification-police-number`;
        }

        // Start the countdown
        this.timer = setInterval(() => {
            if (this.timeRemaining > 0) {
                this.timeRemaining--;
            } else {
                clearInterval(this.timer); // Stop the timer when it reaches 0

                setTimeout(() => {
                    this.updatePayment();
                }, 3000);
            }
        }, 1000);
    },
    computed: {
        hours() {
            return Math.floor(this.timeRemaining / 3600);
        },
        minutes() {
            return Math.floor((this.timeRemaining % 3600) / 60);
        },
        seconds() {
            return this.timeRemaining % 60;
        }
    },
    methods: {
        get_ga_session() {
            const pattern = /_ga_M3KWK0MZTB=GS\d\.\d\.(.+?)(?:;|$)/;
            const match = document.cookie.match(pattern);
            const parts = match?.[1].split(".");

            if (!parts) {
                // Cookie not yet available; wait a bit and try again.
                window.setTimeout(() => getSessionData(callback), 200);
                return;
            }
            const joinSession = [parts.shift(), parts.shift()].join(".");
            return joinSession;
        },
        get_ga_clientid(prop) {
            var cookie = {};
            document.cookie.split(";").forEach(function(el) {
                var splitCookie = el.split("=");
                var key = splitCookie[0].trim();
                var value = splitCookie[1];
                cookie[key] = value;
            });
            return cookie[prop].substring(6);
        },
        downloadQrCode() {
            const canvas = document.querySelector("canvas");

            if (canvas) {
                const image = canvas.toDataURL("image/png");

                const link = document.createElement("a");
                link.href = image;
                link.download = `qr-${this.transaction.external_id}.png`;
                link.click();
            } else {
                console.error("Canvas not found");
            }
        },
        async getPaymentDetail() {
            if (this.isCheckingPayment) return;

            this.isCheckingPayment = true;

            await axios
                .get(
                    `${api_url}/member/event/${this.transaction.external_id}/payment-detail`
                )
                .then(response => {
                    if (response.status === 200) {
                        this.payment_detail = response.data.payment_detail;
                        this.account_number =
                            response.data.payment_detail.account_number !==
                            undefined
                                ? response.data.payment_detail.account_number
                                : "";
                        if (response.data.status === "SUCCESS") {
                            this.isPaymentSuccess = true;
                            localStorage.removeItem("change-payment");
                            window.location.href = `${this.event.detail_url_web}/thank-you`;
                        }
                        this.loader = false;
                        this.loaderCheck = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.loader = false;
                })
                .finally(() => {
                    this.isCheckingPayment = false;
                });
        },

        async updatePayment() {
            this.formUpdate.external_id = this.transaction.external_id;

            try {
                const response = await this.formUpdate.post(
                    `${api_url}/member/event/update-payment`
                );

                if (response.message == "PAYMENT UPDATED") {
                    this.transaction.payment_type = "cod";
                    this.transaction.payment_provider = null;
                    this.transaction.status = "SUCCESS";

                    const dataVaEncrypt = await this.handleEncrypt(
                        JSON.stringify(this.transaction)
                    );
                    localStorage.setItem("transaction-hbd", dataVaEncrypt);

                    window.location.href = `${this.event.detail_url_web}/thank-you`;
                }
            } catch (error) {
                console.log(error, "error");
            }
        },
        async simulate() {
            this.formSimulate.id = this.payment_detail.id;
            try {
                const response = await this.formSimulate.post(
                    `${api_url}/member/event/simulate-qris`
                );

                if (response.error_code == "INACTIVE_QR_CODE") {
                    window.location.href = `${this.event.detail_url_web}/thank-you`;
                }
            } catch (error) {
                console.log(error, "error");
            }
        },
        async handleEncrypt(input) {
            try {
                const encryptText = await encrypt(
                    input,
                    process.env.MIX_ENCODED_SECRET_KEY
                );
                return encryptText;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        async handleDecrypt(input) {
            try {
                return await decrypt(input, process.env.MIX_ENCODED_SECRET_KEY);
            } catch (error) {
                window.location.href = `${this.event.detail_url_web}/verification-police-number`;
                return false;
            }
        },
        async handleGetDataTransactionLocalStorage() {
            this.loader = true;
            const transactionEncrypt = localStorage.getItem("transaction-hbd");
            if (transactionEncrypt) {
                await this.handleDecrypt(transactionEncrypt).then(data => {
                    this.transaction = JSON.parse(data);
                    this.getPaymentDetail();
                    this.calculateTimeRemaining(this.transaction.expired_at); // Kalkulasi waktu tersisa saat komponen dibuat
                    this.checkPaymentInterval();

                    console.log("Transaction = ", this.transaction);
                });
            }
        },
        async handleGetDataEventAttendLocalStorage() {
            const eventAttendEncrypt = localStorage.getItem("event-attend-hbd");
            if (eventAttendEncrypt) {
                await this.handleDecrypt(eventAttendEncrypt).then(data => {
                    const eventAttend = JSON.parse(data);
                    this.event_attend = eventAttend;
                    this.measurementProtocol();
                });
            }
        },
        async measurementProtocol() {
            const timestamp = Date.now().toString();
            const formMeasurement = {
                client_id: this.get_ga_clientid("_ga"), //Collect from cookie
                timestamp_micros: timestamp,
                non_personalized_ads: false,
                Session_id: this.get_ga_session(), //Collect from Cookie
                events: [
                    {
                        name: "success_join_event",
                        params: {
                            event_category: "Joint Event Community",
                            event_action: "Success Join Event",
                            name_event: this.event.name ?? null,
                            id: this.event.id ?? null,
                            transaction_id: this.transaction.external_id,
                            event_type: this.event.type ?? null,
                            start_date: this.event.start_date ?? null,
                            end_date: this.event.end_date ?? null,
                            published_date: this.event.created_at ?? null,
                            motor_category:
                                this.event_attend.category_motor.title ?? null,
                            motor_variant:
                                this.event_attend.variant_motor.name ?? null,
                            payment_option: this.transaction.payment_provider
                                ? `${this.transaction.payment_type} - ${this.transaction.payment_provider}`
                                : this.transaction.payment_type
                        }
                    }
                ]
            };

            await axios
                .post(
                    "https://www.google-analytics.com/mp/collect?api_secret=cj6KYKzJRr6RZm2tGrcs7Q&measurement_id=G-M3KWK0MZTB",
                    formMeasurement,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Connection: "keep-alive",
                            Accept: "*/*",
                            Host: "www.google-analytics.com"
                        }
                    }
                )
                .then(response => {
                    console.log(response);
                })
                .catch(error => console.log(error));
        },
        checkPaymentStatus() {
            this.loaderCheck = true;
            this.getPaymentDetail();
        },
        checkPaymentInterval() {
            try {
                setInterval(() => {
                    this.getPaymentDetail();
                }, 5000);
            } catch (error) {
                console.log(error);
            }
        },
        trackerOnloadVa(payment) {
            let data = {
                event: "paymentEvent",
                "eventDetail.category": "Join Event Community",
                "eventDetail.action": "Waiting for Payment",
                eventName: this.event.name, //Event Name
                id: this.event.id, //Event ID
                transaction_id: payment.external_id, //Transaction ID
                eventType: this.event.type, //Event Type
                startDate: this.event.start_date, //Event Start Date
                endDate: this.event.end_date, //Event End Date
                publishedDate: this.event.created_at, //Event Created Date
                motorCategory: this.event_attend.category_motor.name, //Selected Motor category
                motorVariant: this.event_attend.variant_motor.name, //Selected Motor Variant
                paymentOption: "Virtual Account Transfer - BCA", //Selected Payment Option
                province: this.event.province //Event Province
            };
            console.log(data, "Waiting for Payment");
            dataLayer.push(data);
        },
        calculateTimeRemaining(expired_at) {
            const now = new Date().getTime(); // Waktu saat ini dalam milidetik
            const expiredTime = new Date(expired_at).getTime(); // Convert expired_at ke milidetik
            const diff = expiredTime - now; // Selisih waktu dalam milidetik
            this.timeRemaining = Math.floor(diff / 1000); // Convert ke detik
        }
    }
};
</script>
<style scoped lang="scss">
.message-join {
    position: relative;
    margin: 13px 0;
    padding-bottom: 13px;
    text-align: center;
    color: #e61c33;
    font-weight: 500;
    font-size: 15px;
}

label {
    margin-bottom: 0 !important;
}

.wrapper-popup {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // padding: 10px;
        width: 558px;
        overflow: hidden;

        @media screen and (max-width: 787px) {
            width: 100%;
        }

        .wrapper-va {
            position: relative;

            .inner-va-information {
                color: #000;
                background-color: #eaeaea;
                padding: 15px 25px;

                h5 {
                    font-size: 20px;
                    font-weight: 700;
                }

                p {
                    font-size: 15px;
                    font-weight: 300;
                    color: #000;

                    .va-total,
                    .va-timeout {
                        font-weight: 700;
                    }

                    .va-timeout {
                        color: #e61b33;
                    }
                }
            }

            .inner-va-number {
                padding: 20px 25px;
                margin-bottom: 15px;

                p {
                    color: #000;
                    font-size: 16px;
                }

                .va-number {
                    padding: 30px;
                    color: #000;
                    // background-color: #eaeaea;
                    border-radius: 10px;
                    text-align: center;
                    display: flex;
                    justify-content: center;

                    .va-copy {
                        a {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 10px;
                            border-radius: 10px;
                            gap: 10px;

                            &:hover {
                                padding: 10px;
                                background-color: #000;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            color: rgba(40, 40, 40, 1);
            height: 100%;

            p {
                font-size: 15px;
                width: 400px;
                color: rgba(63, 63, 63, 1);

                @media screen and (max-width: 787px) {
                    width: 100%;
                }
            }

            .display-product {
                position: relative;
                display: flex;
                gap: 15px;
                padding-bottom: 2rem;

                .product-info {
                    padding-top: 10px;

                    .title {
                        font-size: 18px;
                        font-weight: 700;
                    }

                    .price {
                        font-size: 18px;
                        font-weight: 700;
                        color: rgba(230, 27, 51, 1);
                    }
                }
            }

            .payment-methods {
                padding-bottom: 2rem;

                .radio-container {
                    display: flex;
                    align-items: center;
                    flex-direction: row-reverse;
                    width: 100%;
                    justify-content: space-between;
                    border: 1px solid rgba(216, 216, 216, 1);
                    border-right: none;
                    border-left: none;
                    border-top: none;
                    font-size: 16px;
                    padding: 13px 0;
                    font-weight: 600;

                    .radio-label {
                        img {
                            margin-right: 10px;
                        }
                    }
                }

                .radio-container input[type="radio"] {
                    display: none;
                }

                .radio-custom {
                    width: 20px;
                    height: 20px;
                    border: 2px solid red;
                    border-radius: 50%;
                    display: inline-block;
                    position: relative;
                    cursor: pointer;
                }

                .radio-custom::after {
                    content: "";
                    width: 10px;
                    height: 10px;
                    background-color: red;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: none;
                }

                input[type="radio"]:checked + .radio-custom::after {
                    display: block;
                }

                .list-items-va {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    padding-top: 10px;
                    padding-left: 55px;
                    border-radius: 5px;
                    font-size: 14px;
                    font-weight: 600;

                    .item-link {
                        border: 1px solid #d8d8d8;
                        padding: 8px;
                        border-radius: 6px;
                        font-size: 14px;
                        font-weight: 600;
                        cursor: pointer;
                        color: #000;
                        text-decoration: none;

                        img {
                            width: 45px;
                            margin-right: 10px;
                        }
                    }

                    .active {
                        border-color: #e61b33;
                    }
                }
            }

            .wrapper-button-action {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 20px;
            }

            .btn {
                width: 100%;
                max-width: 100%;
                font-weight: 700;
                font-size: 14px;
                padding: 0;
                height: 42px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background-color: #333 !important;
                    color: #fff;
                }
            }

            .red-button {
                width: 100%;
                background-color: #e61b33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}
</style>
